
export default function PerfectFor() {
  const items = [
    'Orientation & Welcome Weeks',
    'Student Activities Programming',
    'Fall/Spring Fests & De-Stress Events',
    'Late-Night Campus Programming',
    'Greek Life (Fraternities & Sororities)'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center mb-16 text-zinc-900">
          Perfect For
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {items.map((item, index) => (
            <div
              key={index}
              className="group bg-zinc-900 border border-zinc-800 rounded-2xl p-8 hover:border-red-600 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-checkbox-circle-fill text-2xl text-red-600"></i>
                </div>
                <p className="text-lg font-semibold text-white leading-relaxed">
                  {item}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
